import React, { Component } from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { TextField, SelectField } from "redux-form-material-ui";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import { RaisedButton, FlatButton, MenuItem } from "material-ui";
import {
	actionCreateUserControl,
	actionUpdateUserControl,
	asyncCheckEmail
} from "../../actions/UserControlActions";
import { actionGetRolList } from "../../actions/DataActions";
import {
	required,
	validateEmail,
	password,
	confirmPasswordUser
} from "../../common/validaciones";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import {
	ROL_ADMIN,
	ROL_SUB_ADMIN,
	ROL_OPERADOR_RECAUDA
} from "../../common/Constants";
import { USER_CONTROL } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR, handleSubmitFail } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import "./UserControl.css";

let _handleSubmitFail;

class UserControlForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_SHOW
				? this.returnStateShowUserControl()
				: {};
		this.state = state;
		this.initializeValues = this.initializeValues.bind(this);
		this.returnOnSubmit = this.returnOnSubmit.bind(this);

		_handleSubmitFail = handleSubmitFail.bind(this);
	}

	componentWillMount() {
		this.props.actionGetRolList();
		if (
			!this.props.modeCRU ||
			(this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN)
		) {
			this.props.history.push(USER_CONTROL);
		} else {
			if (this.props.modeCRU === MODE_CRU_CREATE) {
				this.initializeValues(false);
			} else {
				if (
					this.props.modeCRU === MODE_CRU_UPDATE ||
					this.props.modeCRU === MODE_CRU_SHOW
				) {
					this.initializeValues(true);
				}
			}
		}
	}

	returnStateShowUserControl() {
		const state = {
			enableField: true
		};
		return state;
	}

	initializeValues(flag) {
		if (flag) {
			this.setState({
				title: "Modificar Usuario",
				subTitle: "Edite Usuario"
			});

			const form = this.props.userControl;
			const values = {
				id: form.id,
				email: form.email,
				password: form.password,
				repassword: form.password,
				rol: form.rol[0].id,
				empresa: !form.company ? null : form.company.name,
				cuit: !form.company ? null : form.company.cuit
			};
			this.props.initialize(values);
		} else {
			this.setState({
				title: "Alta de Usuario",
				subTitle: "Agregar Usuario"
			});
			this.props.initialize({
				id: 0,
				email: null,
				password: null,
				repassword: null,
				rol: null
			});
		}
	}

	onSubmit(formValues) {
		const { email = "", password = "", rol = "" } = formValues;

		const values = {
			//id : valor,
			email: email,
			password: password
		};
		const role = rol;
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			this.props.actionCreateUserControl(values, role, this.returnOnSubmit);
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			values.id = this.props.userControl.id;
			this.props.actionUpdateUserControl(values, role, this.returnOnSubmit);
		}
	}

	returnOnSubmit(response) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Usuario creado");
				this.props.history.push(USER_CONTROL);
			} else if (response === ERROR)
				Util.showNoty(ERROR, "Error al crear usuario");
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Usuario Modificado");
				this.props.history.push(USER_CONTROL);
			} else if (response === ERROR)
				Util.showNoty(ERROR, "Error al modificar usuario");
		}
	}

	render() {
		const disabled =
			this.props.rol === ROL_OPERADOR_RECAUDA ||
			this.props.modeCRU === MODE_CRU_SHOW;
		const disabeEdicion = this.props.modeCRU === MODE_CRU_UPDATE;
		const { handleSubmit } = this.props;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(this.props.modeCRU, "Usuario")}
					<CardText>
						<form>
							<div className="content-papercard">
								<Field
									name="email"
									component={TextField}
									floatingLabelText="Email"
									validate={[validateEmail, required]}
									fullWidth
									disabled={disabled}
								/>
								<Field
									component={TextField}
									className="textField"
									name="password"
									type="password"
									fullWidth
									hintText="Contraseña"
									floatingLabelText="Contraseña"
									floatingLabelFixed
									validate={
										this.props.modeCRU !== MODE_CRU_UPDATE
											? [required, password]
											: null
									}
									disabled={disabled || disabeEdicion}
								/>
								<Field
									name="repassword"
									type="password"
									component={TextField}
									floatingLabelText="Confirmar Contraseña"
									validate={
										this.props.modeCRU !== MODE_CRU_UPDATE
											? [confirmPasswordUser, required]
											: null
									}
									disabled={disabled || disabeEdicion}
									fullWidth
								/>
								<div className="columns-column-simple ">
									<Field
										name="rol"
										component={SelectField}
										floatingLabelText="Roles"
										fullWidth
										disabled={
											disabled ||
											(this.props.modeCRU === MODE_CRU_UPDATE &&
												(this.props.userControl.rol[0].id === 2 ||
													this.props.userControl.rol[0].id === 9 ||
													this.props.userControl.rol[0].id === 10))
										}
										validate={
											this.props.modeCRU === MODE_CRU_UPDATE &&
											(this.props.userControl.rol[0].id !== 2 ||
												this.props.userControl.rol[0].id !== 9 ||
												this.props.userControl.rol[0].id !== 10)
												? required
												: null
										}
									>
										{(this.props.modeCRU === MODE_CRU_UPDATE ||
											this.props.modeCRU === MODE_CRU_SHOW) &&
										(this.props.userControl.rol[0].id === 2 ||
											this.props.userControl.rol[0].id === 9 ||
											this.props.userControl.rol[0].id === 10)
											? _.map(this.props.rolList, (rol, i) => {
													return (
														<MenuItem
															key={i + 1}
															value={rol.id}
															primaryText={rol.rol}
														/>
													);
											  })
											: _.map(this.props.rolList, (rol, i) => {
													if (rol.id !== 2 && rol.id !== 9 && rol.id !== 10) {
														return (
															<MenuItem
																key={i + 1}
																value={rol.id}
																primaryText={rol.rol}
															/>
														);
													}
											  })}
									</Field>
								</div>
								<div className="columns-column-simple">
									{this.props.userControl ? (
										this.props.userControl.rol[0].id === 2 ? (
											<Field
												name="empresa"
												component={TextField}
												floatingLabelText="Razón Social"
												disabled
											/>
										) : null
									) : null}
									{this.props.userControl ? (
										this.props.userControl.rol[0].id === 2 ? (
											<Field
												name="cuit"
												component={TextField}
												floatingLabelText="Cuit"
												className={"left10"}
												disabled
											/>
										) : null
									) : null}
								</div>
							</div>
							<div className="top20 text-right">
								<FlatButton
									label="Cancelar"
									onClick={() => this.props.history.push(USER_CONTROL)}
									style={{ margin: 5 }}
								/>
								<RaisedButton
									label="Aceptar"
									disabled={this.state.enableField}
									primary
									style={{ margin: 5 }}
									onClick={handleSubmit(this.onSubmit.bind(this))}
								/>
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}

const asyncValidate = (
	values,
	dispatch,
	props,
	currentFieldName,
	userControl
) => {
	if (currentFieldName === "email") {
		let emails = values.email;
		let id = values.id;
		return asyncCheckEmail(emails, id).then(response => {
			if (response !== null) {
				if (response.email) {
					let msg = "Ya existe un usuario con este Email : " + emails;

					// eslint-disable-next-line
					throw {
						email: msg
					};
				}
			}
		});
	} else {
		return new Promise(async (resolve, reject) => {
			resolve("");
		});
	}
};

function mapStateToProps(store) {
	const selector = formValueSelector("UserControlForm");
	return {
		userControl: store.userControl.userControl,
		modeCRU: store.userControl.modeCRU,
		rol: store.app.rol,
		rolList: store.data.rolList,
		formValues: selector(store, "email", "id")
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionCreateUserControl,
			actionUpdateUserControl,
			actionGetRolList,
			asyncCheckEmail
		},
		dispatch
	);
}

export default reduxForm({
	form: "UserControlForm",
	asyncValidate,
	onSubmitFail: errors => _handleSubmitFail(errors)
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(UserControlForm)
);



// WEBPACK FOOTER //
// ./src/screens/UserControl/UserControlForm.js